<div
  class="relative bg-secondary w-[30px] p-1 group rounded-lg border border-cinza cursor-pointer"
  (click)="handleClick()"
>
  <div
    class="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 hidden group-hover:block bg-red-light text-sm text-primary rounded py-1 px-2 whitespace-nowrap z-10"
  >
    Voltar
  </div>
  <img ngSrc="/icons/backArrow.svg" alt="back" width="30" height="30" />
</div>
